class ThemeStoreClass {
	constructor() {
		this.themes = {
			standard: this.standard(),
			delek: this.delek(),
			ballmer: this.ballmer(),
			vampire: this.vampire(),
		}

    if (localStorage.getItem('theme')) {
      this.active = localStorage.getItem('theme')
    } else {
    	this.active = 'standard'
    }

    if (localStorage.getItem('chart_type')) {
      this.chartType = localStorage.getItem('chart_type')
    } else {
    	this.chartType = 'ohlc'
    }
	}

	getChartType() {
		return this.chartType
	}

	setChartType(type) {
		this.chartType = type
		localStorage.setItem('chart_type', type)
	}

	getAllChartTypes() {
		return [['ohlc', 'Bar'], ['candl', 'Candlestick'], ['ha', 'Heikin Ashi']]
	}

	getAllNames() {
		return Object.keys(this.themes)
	}

	set(name) {
		if (this.themes[name]) {
			this.active = name
			localStorage.setItem('theme', name)
		}
	}

	name() {
		return this.active
	}

	get() {
		return this.themes[this.active]
	}

	standard() {
		return {
			dark: false,
			bg: "#efe7d2",
			axis_stroke: "#000000",
			volume_green: "#c6e6cb",
			volume_red: "#e7caca",
			price_green: "#6ba583",
			price_red: "#d75442",
			candle_green_fill: "#6ba583",
			candle_green_stroke: "#6ba583",
			candle_red_fill: "#d75442",
			candle_red_stroke: "#d75442",
			bb_stroke: "#148484",
			bb_fill: "#d7f2f2",
			trendline: "#cc0000",
			edge_green: "#6ba583",
			edge_red: "#d75442",
			crosshair: "#333333",
		}
	}

	delek() {
		return {
			dark: true,
			bg: "#0c0c11",
			axis_stroke: "#0bb2a0",
			volume_green: "#076a15",
			volume_red: "#660a0a",
			price_green: "#0cb825",
			price_red: "#e80015",
			candle_green_fill: "transparent",
			candle_green_stroke: "#0cb825",
			candle_red_fill: "#e80015",
			candle_red_stroke: "#e80015",
			bb_stroke: "#3b82e6",
			bb_fill: "#0c3131",
			trendline: "#cc0000",
			edge_green: "#0cb825",
			edge_red: "#c51c1c",
			crosshair: "#68f2ae",
		}
	}

	ballmer() {
		return {
			dark: false,
			bg: "#0c0c11",
			axis_stroke: "#373737",
			volume_green: "#bbd3f0",
			volume_red: "#edbdc0",
			price_green: "#30619d",
			price_red: "#882a30",
			candle_green_fill: "transparent",
			candle_green_stroke: "#30619d",
			candle_red_fill: "#882a30",
			candle_red_stroke: "#882a30",
			bb_stroke: "#68c01c",
			bb_fill: "transparent",
			trendline: "#cc0000",
			edge_green: "#30619d",
			edge_red: "#882a30",
			crosshair: "#333333",
		}
	}

	vampire() {
		return {
			dark: true,
			bg: "#000000",
			axis_stroke: "#b2b2b2",
			volume_green: "#8c8787",
			volume_red: "#980505",
			price_green: "#ffffff",
			price_red: "#c60606",
			candle_green_fill: "transparent",
			candle_green_stroke: "#ffffff",
			candle_red_fill: "#c60606",
			candle_red_stroke: "#c60606",
			bb_stroke: "#596a83",
			bb_fill: "transparent",
			trendline: "#cc0000",
			edge_green: "#ffffff",
			edge_green_text: "#000000",
			edge_red: "#c60606",
			crosshair: "#b2b2b2",
		}
	}
}

var ThemeStore = new ThemeStoreClass()

export { ThemeStore }



// WEBPACK FOOTER //
// ./src/stores/ThemeStore.js